module.exports = __webpack_public_path__ + "img/feature-list.14d7ba61.svg";